import { StyleRules } from '@material-ui/core/styles';
import { StepConnectorClasskey } from '@material-ui/core/StepConnector';

import { core as theme } from '../styles/core';

export const MuiStepConnector: Partial<StyleRules<StepConnectorClasskey>> = {
  line: {
    borderColor: theme.palette.grey.A400,
  },
  alternativeLabel: {
    left: 'calc(-50% + 20px)',
    right: 'calc(50% + 20px)',
  },
};
